
import { defineComponent } from "vue";

export default defineComponent({
  name: 'GtrTimer',
  props: {
    seconds: { required: true, type: Number, default: 0 },
    paused: { required: true, type: Boolean, default: true }
  },
  data () {
    return {
      timer: 0,
      intervalId: null as number | null
    }
  },
  computed: {
    timerDisplay(): string {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  watch: {
    seconds (new_seconds: number) {
      this.timer = new_seconds
    },
    paused (newVal: boolean) {
      if (newVal) {
        this.clearTimer()
      }  else {
        this.startTimer()
      }
    }
  },
  methods: {
    startTimer() {
      this.clearTimer();
      this.intervalId = window.setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
          if (this.timer === 0) {
            this.$emit('out-of-time');
            this.clearTimer();
          }
        }
      }, 1000);
    },
    clearTimer() {
      if (this.intervalId !== null) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
  mounted() {
    this.timer = this.seconds;
    if (!this.paused) {
      this.startTimer();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  }
})
